import PropTypes from 'prop-types';
import React, { Component } from 'react';
import SocialNav from './footer/social_nav';
import About from './common/about';
import FooterEmailAcquisition from './footer/footer_email_acquisition';
import InternationalLink from './footer/international_link';
import withViewportScrollTracking from './hocs/withViewportScrollTracking';
import { setLocation } from '../utils/dom';
import { sendAnalyticsEvent } from '../utils/analytics';
import RosettaFormattedMessage from './common/rosetta_formatted_message';

import {map, get, find, reject} from 'lodash';
import { StaticAssets } from './common/static_assets.js';
import {
  EDITION_ID_DE_DE,
  EDITION_ID_EN_AU,
  EDITION_ID_EN_US,
  EDITION_ID_FR_FR,
  GEOLOCATION_US,
  GEOLOCATION_FR,
  GEOLOCATION_DE,
  GEOLOCATION_UK,
} from '../constants';

const ACCESSIBILITY_STATEMENT_LINK = 'https://www.vice.com/en/page/vice-media-accessibility-statement';
const ACCESSIBILITY_LOGO_LINK = 'https://www.essentialaccessibility.com/refinery29?utm_source=refinery29homepage&utm_medium=iconlarge&utm_term=iconlarge&utm_content=header&utm_campaign=refinery29';
const ACCESSIBILITY_ALT_TEXT = 'This icon serves as a link to download the eSSENTIAL Accessibility assistive technology app for individuals with physical disabilities. It is featured as part of our commitment to diversity and inclusion.';

const Aux = props => props.children;

const titleFromModules = (modules) => {
  const heroModule = find(modules, { type: 'hero' });
  if (heroModule) {
    return heroModule.title;
  }

  const pageHeaderModule = find(modules, { type: 'page-header' });
  if (pageHeaderModule) {
    return pageHeaderModule.title;
  }

  return null;
};

const PRIVACY_MANAGER_IDS = {
  [GEOLOCATION_US]: 1166997,
  [GEOLOCATION_UK]: 1166981,
  [GEOLOCATION_FR]: 1166982,
  [GEOLOCATION_DE]: 1166983
};

const PRIVACY_MANAGER_TEXT = {
  [GEOLOCATION_US]: 'Do Not Sell or Share My\nPersonal Information',
  [GEOLOCATION_UK]: 'Manage My Privacy Settings',
  [GEOLOCATION_FR]: 'Gérer Mes Paramétres de\nConfidentialité',
  [GEOLOCATION_DE]: 'Personenbezogene Daten'
};

const NEWSLETTER_SIGNUP_LINK = {
  [GEOLOCATION_US]: 'https://jump.refinery29.com/join/24/signup-all-newsletters?utm_source= footer&utm_medium=emailsignup',
  [GEOLOCATION_UK]: 'https://jump.refinery29.com/join/signup-gb-2020',
}

export class Footer extends Component {
  /*
   * Note that the international links are not handled by this. Those have
   * a different GA event.
   */
  constructor(props) {
    super(props);
    this.state = {
      information: this.props.links.information,
      privacyManagerId: PRIVACY_MANAGER_IDS[props.geolocation],
      privacyManagerText: PRIVACY_MANAGER_TEXT[props.geolocation],
      newsletterSignupLink: NEWSLETTER_SIGNUP_LINK[props.geolocation],
    };
  }

  handleDoNotSellMyInfo = href => {
    if (typeof get(window, 'window._sp_.usnat.loadPrivacyManagerModal') === 'function' && this.props.geolocation === GEOLOCATION_US) {
      window._sp_.usnat.loadPrivacyManagerModal(this.state.privacyManagerId);
    } else if(typeof get(window, 'window._sp_.gdpr.loadPrivacyManagerModal') === 'function') {
      window._sp_.gdpr.loadPrivacyManagerModal(this.state.privacyManagerId);
    }

    sendAnalyticsEvent(
      'Footer Link',
      'Click',
      href
    );
  }

  displayAccessibilityIcon = () => {
    const { edition_data } = this.props;
    return [EDITION_ID_FR_FR, EDITION_ID_DE_DE].indexOf(edition_data.id) === -1;
  }

  displayNewsletterSignup = () => {
    const { edition_data } = this.props;
    return [EDITION_ID_FR_FR, EDITION_ID_DE_DE, EDITION_ID_EN_AU].indexOf(edition_data.id) === -1;
  }

  handleClick = event => {
    event.preventDefault();
    const { href } = event.currentTarget;
    if (href.indexOf('#do-not-sell-my-info') > 0) {
      this.handleDoNotSellMyInfo(href);
      return;
    }

    sendAnalyticsEvent(
      'Footer Link',
      'Click',
      href,
      { hitCallback: () => setLocation(href) }
    );
  }

  render() {
    const {
      links, edition_data, newsletters, meta_data, modules, pageId
    } = this.props;

    const newsletter = find(newsletters, { channel: 'default' });
    return (
      <Aux>
        {meta_data.about &&
          <About
            about={meta_data.about}
            pageId={pageId}
            title={titleFromModules(modules)}
          />
        }
        <footer className="global-footer">
          <div className="refinery-footer">
            {edition_data.id === EDITION_ID_EN_AU && (
              <div className="au-acknowledgement">In the spirit of reconciliation, Refinery29 Australia acknowledges the Traditional Custodians of country throughout Australia and their connections to land, sea and community. We pay our respect to their Elders past and present and extend that respect to all Aboriginal and Torres Strait Islander peoples today.</div>
            )}
            <div className="social-container">
              <img className="logo" alt="" src={StaticAssets.r29LogoRegMarkB} />
              <SocialNav edition_data={edition_data} />
            </div>
            <div className="links company">
              <span className="column-header">
                <RosettaFormattedMessage parentFilename={__filename}
                  id="company"
                  description="Message that displays as a column header in the footer"
                  defaultMessage="COMPANY"
                />
              </span>
              <ul>
                {
                  map(links.company, ({ href, name, className }) => {
                  const aProps = { href, onClick: this.handleClick };
                  if (className) {
                    aProps.className = className;
                  }
                    return <li key={name}><a {...aProps}>{name}</a></li>;
                  })
                }
              </ul>
            </div>
            <div className="links information">
              <span className="column-header">
                <RosettaFormattedMessage parentFilename={__filename}
                  id="information"
                  description="Message that displays as a column header in the footer"
                  defaultMessage="INFORMATION"
                />
              </span>
              <ul>
                {
                  map(this.state.information, ({ href, rel, name, className }) => {
                    const aProps = { href, rel, onClick: this.handleClick };
                    if (className) {
                      aProps.className = className;
                    }
                    return <li key={name}><a {...aProps}>{name}</a></li>;
                  })
                }
                <li key="Do Not Sell or Share My Personal Information">
                  <a
                    href="#do-not-sell-my-info"
                    name="Do Not Sell or Share My Personal Information"
                    className="privacy-text"
                    onClick={this.handleClick}
                  >
                    {this.state.privacyManagerText}
                  </a>
                </li>
              </ul>
            </div>
            <div className="links editions">
              <span className="column-header">
                <RosettaFormattedMessage parentFilename={__filename}
                  id="editions"
                  description="Message that displays as a column header in the footer"
                  defaultMessage="EDITIONS"
                />
              </span>
              <ul>
                {
                  map(links.editions, ({ editionId, editionBasename, href, name }) =>
                    <InternationalLink
                      key={editionId}
                      editionBasename={editionBasename}
                      name={name}
                      href={href}
                      edition_data={edition_data}
                    />
                  )
                }
              </ul>
            </div>
            <div className="email-signup">
              {this.displayNewsletterSignup() && 
                <span className="column-header">
                  <a
                    href={this.state.newsletterSignupLink}
                  >
                    <RosettaFormattedMessage
                      parentFilename={__filename}
                      id="newsletter_signup"
                      description="Message that displays as a column header in the footer"
                      defaultMessage="NEWSLETTER SIGN-UP"
                    />
                  </a>
                </span>
              }
            </div>
            <div className="vmg-footer">
            {this.displayAccessibilityIcon() &&
                <div className="accessibility-logo">
                <a href={ACCESSIBILITY_LOGO_LINK}><img alt={ACCESSIBILITY_ALT_TEXT} src={StaticAssets.accessibilityLogo} /></a>
                </div>
            }
              <div className="copyright">
                &copy; {new Date().getFullYear()} REFINERY29
              </div>
            </div>
          </div>
        </footer>
      </Aux>
    );
  }
}

Footer.propTypes = {
  links: PropTypes.shape({
    company: PropTypes.arrayOf(PropTypes.shape({
        href: PropTypes.string,
      name: PropTypes.string
    })),
    information: PropTypes.arrayOf(PropTypes.shape({
        href: PropTypes.string,
      name: PropTypes.string
    })),
    international: PropTypes.arrayOf(PropTypes.shape({
        href: PropTypes.string,
      name: PropTypes.string
    }))
  }).isRequired,
  edition_data: PropTypes.object.isRequired,
  geolocation: PropTypes.string,
  newsletters: PropTypes.arrayOf(PropTypes.object),
  meta_data: PropTypes.object.isRequired,
  modules: PropTypes.array.isRequired,
  pageId: PropTypes.number.isRequired,
};

const decorator = withViewportScrollTracking({
  eventParams: () => [
    'Scroll Depth',
    'Scroll',
    'Reached bottom of page'
  ]
});

export default decorator(Footer);
